import { render, staticRenderFns } from "./CoreModule.vue?vue&type=template&id=5ad03364"
import script from "./CoreModule.vue?vue&type=script&lang=js"
export * from "./CoreModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports